import { useEffect, useState } from 'react'
import { Box, Center, Text } from '@chakra-ui/react'

const ErrorPage = () => {
  const refreshPage = () => {
    window.location.reload()
  }

  // state to store count
  const [count, setCount] = useState(50)
  useEffect(() => {
    if (count > 0) {
      setInterval(() => {
        setCount(count - 1)
      }, 5000)
    }
    if (count === 0) {
      refreshPage()
    }
  }, [count])

  return (
    <Center height={'100vh'}>
      <Box>
        <Text align='center' pb='10' fontSize={'42px'} fontWeight='bold' color='#005050'>
        Internal Error
        </Text>

        <Text justifyContent={'center'} display={'flex'} gap='8' fontSize={'16px'}>
          <Text fontSize={'24px'} fontWeight='black'>
          Oops!
          </Text>
          <Text pt='8'></Text>
        </Text>
        <Text py='10' my='10' textAlign={'center'}>
        There may be some problem with the page you are looking for, please refresh the page or try again later
        </Text>
        <Text textAlign={'center'} className='pt-4'>
          {count} It will automatically reload after seconds
        </Text>
      </Box>
    </Center>
  )
}

export default ErrorPage
